module.exports = __webpack_public_path__ + "img/riwayat_cuti.1f2c4318.png";